import { cn } from 'lib/utils'

export const Skeleton = ({ className }: { className: string }) => (
  <div
    aria-live="polite"
    aria-busy="true"
    className={cn('h-4 animate-pulse select-none rounded-md bg-bg3', className)}
  />
)

export const SVGSkeleton = ({ className }: { className: string }) => (
  <svg className={`${className} animate-pulse rounded bg-muted`} />
)
